export const GLOBAL_WHATSAPP_CARD_IDS = {
  cardId: 'global-whatsapp-metrics',
};

export const GLOBAL_WHATSAPP_CARD_TEXT = {
  cardTitle: 'WhatsApp',
  utilityMessagesName: 'Utility messages sent',
  marketingMessagesName: 'Marketing messages sent',
};
